import { getEmailMessage } from './defaultMessage/leads';

export const MODAL_TITLES = {
  agent: 'Contatta l\'agente',
  agency: 'Contatta l\'agenzia',
  private: 'Contatta l\'inserzionista',
};

export const getType = (publisher) => {
  const {
    publisherType,
    isAgentPro,
  } = publisher;

  return isAgentPro
    ? 'agent'
    : publisherType.toLowerCase();
};

export const userDevice = (device) => {
  let from;
  switch (device) {
    case 'smartphone':
      from = 'PM';
      break;
    case 'tablet':
      from = 'PT';
      break;
    default:
      from = 'PD';
  }
  return from;
};

export const defaultMessage = ({
  isPublisherLead = false,
  propertyTypeGroup = null,
  propertyType = null,
  wantVirtualTour = false,
  isProjectProfile = false,
  hasNoMedia = false,
}) => {
  if (isPublisherLead) {
    return 'Buongiorno, sono alla ricerca di un immobile, vorrei essere ricontattato.\nGrazie';
  }
  const type = propertyType || propertyTypeGroup;
  let context = type === 'attivita-licenza-commerciale' ? 3 : 0;
  if (wantVirtualTour || hasNoMedia) {
    context = wantVirtualTour
      ? 1
      : 2;
  }
  return getEmailMessage(type, context, isProjectProfile);
};

export const getProxyRoute = (app, leadType) => {
  let proute;
  if (leadType === 'agency') {
    proute = '/portal-srp/api/v1/mycasa/searchAgency';
  } else {
    switch (app) {
      case 'P20':
        proute = `/client-pdp/api/v1/leads/${leadType}`;
        break;
      case 'P18':
        proute = leadType === 'specific'
          ? '/portal-srp/api/v1/mycasa/searchSpecific'
          : '/portal-srp/api/v1/mycasa/searchGeneric';
        break;
      default:
    }
  }
  return proute;
};
